export interface BookingCustomStatus {
  id: number;
  name: string;
  color: string;
  systemStatus: string;
  sortOrder: number | null;
  bookingCount: number;
}

export interface BookingStatusSettings {
  showCustomStatusesOnCalendar: boolean;
}

export interface BookingCustomStatusSetup {
  customStatuses: BookingCustomStatus[];
  settings: BookingStatusSettings;
}

export interface BookingCustomStatusDraft {
  id: number | null;
  draftKey: string;
  name: string;
  color: string;
  systemStatus: string;
  bookingCount: number;
}

export interface BookingStatusSettingsDraft {
  showCustomStatusesOnCalendar: boolean;
}

export const getReadableTextColor = (backgroundColor: string) => {
  const hex = backgroundColor.replace('#', '');
  const fullHex = hex.length === 3 ? hex.replace(/./g, (hexDigit) => hexDigit + hexDigit) : hex;
  const red = parseInt(fullHex.slice(0, 2), 16);
  const green = parseInt(fullHex.slice(2, 4), 16);
  const blue = parseInt(fullHex.slice(4, 6), 16);

  if ([red, green, blue].some(Number.isNaN)) {
    return '#000000';
  }

  return (red * 299 + green * 587 + blue * 114) / 1000 > 150 ? '#000000' : '#FFFFFF';
};
